import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/cost_elements', { params });
  },
  create(data) {
    return axios.post('/v1/cost_elements', data);
  },
  detail(id) {
    return axios.get(`/v1/cost_elements/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/cost_elements/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/cost_elements/${id}`);
  }
};
